/* eslint-disable max-len */
export default {
    title: 'O firmie',
    text: [
        'Ta strona zawiera informację na temat Lemlock.',
        '<strong>Siedziba i dane adresowe</strong>',
        '<strong>Sagiton Sp. z o.o.</strong>',
        'Fabryczna 19<br/> 53-609 Wrocław<br/> Polska',
        'Mobile: +48 71 758 00 70<br/> E-mail: contact@sagiton.pl',
        'NIP: PL8943044096<br/> REGON: 022069799<br/> KRS: 0000449601<br/> Zarząd: Marcin Michalski, Grzegorz Mąkosa, Adam Końca',
        'Lemlock jest znakiem towarowym należącym do Sagiton Sp. z o.o.<br/> Wszystkie prawa zastrzeżone, powielanie informacji zawartych na tej stronie zabronione.'
    ]
};



// WEBPACK FOOTER //
// ./src/i18n/pl/legal.js